import axios from "axios";
import { API_URL } from "constants/ApiUrl";
import { toast } from "react-toastify";

const service = axios.create({
  baseURL: `${API_URL}/`,
  timeout: 60000,
});
const TOKEN_PAYLOAD_KEY = "authorization";

// Config
// API Request interceptor
service.interceptors.request.use(
  (config) => {
    const jwtToken = localStorage.getItem("authUser") || null;

    if (jwtToken) {
      config.headers[TOKEN_PAYLOAD_KEY] = "Bearer " + jwtToken;
    }

    return config;
  },
  (error) => {
    // Do something with request error here
    // notification.error({
    //   message: "Error",
    // })
    Promise.reject(error);
  }
);

// API respone interceptor
service.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const prevRequest = error?.config;
    if (
      error?.response?.status === 401 &&
      (error?.response?.data?.message === "Invalid or expired token." ||
        error?.response?.data?.message === "Access denied. No token provided.")
    ) {
      localStorage.removeItem("authUser");
      toast.error("Please login again", {
        position: "top-center",
      });
    } else {
      error?.response?.data?.message &&
        toast.error(error?.response?.data?.message || "Error", {
          position: "top-center",
        });
    }

    return Promise.reject(error);
  }
);

export default service;
